import { Component } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

import { markAsTouched, updateValueAndValidity } from "@dffedb/forms";
import { LocalStorage } from "@dffedb/util/src";

@Component({
    templateUrl: "./mit-forbrug-send-fejl-dialog.component.html",
    styleUrls: ["./mit-forbrug-send-fejl-dialog.component.scss"],
    host: {
        dialog: "true",
        "aria-modal": "true",
        "aria-labelledby": "mit-forbrug-send-fejl-dialog-title"
    }
})
export class MitForbrugSendFejlDialogComponent {
    public formGroup: UntypedFormGroup;
    public forbrugerNr = this.localStorage.getItem("userCredentials");

    constructor(public dialogRef: MatDialogRef<MitForbrugSendFejlDialogComponent>, private readonly localStorage: LocalStorage) {
        this.formGroup = new UntypedFormGroup({
            beskrivelse: new UntypedFormControl("", [Validators.required]),
            email: new UntypedFormControl("", [Validators.required, Validators.email]),
            telefon: new UntypedFormControl("", []),
            accepter: new UntypedFormControl(false, [Validators.requiredTrue]),
            forbrugerNummer: new UntypedFormControl(this.forbrugerNr, [])
        });
    }

    public onSend(): void {
        markAsTouched(this.formGroup);
        updateValueAndValidity(this.formGroup);
        if (!this.formGroup.valid) {
            return;
        }
        this.dialogRef.close(this.formGroup.getRawValue());
    }
}
